<article
  class="admin-stat"
  [class.admin-stat--primary]="accent() === 'primary'"
  [class.admin-stat--success]="accent() === 'success'"
  [class.admin-stat--purple]="accent() === 'purple'"
  [class.admin-stat--warning]="accent() === 'warning'"
  [attr.aria-busy]="loading()"
>
  <div class="admin-stat__content">
    @if (loading()) {
      <span class="admin-stat__value admin-stat__value--placeholder" aria-hidden="true">—</span>
    } @else if (value() !== null && value() !== '') {
      <span class="admin-stat__value">
        @if (typeof value() === 'number') {
          {{ value() | number }}
        } @else {
          {{ value() }}
        }
      </span>
    } @else {
      <span class="admin-stat__value admin-stat__value--placeholder">—</span>
    }
    <span class="admin-stat__label">{{ labelKey() | translate }}</span>
    @if (hintKey()) {
      <span class="admin-stat__hint">{{ hintKey()! | translate }}</span>
    }
  </div>
</article>
